import { all, takeLatest } from "redux-saga/effects";
import {
  associadoEspecialRequest,
  atualizarAdesaoRequest,
  dadosCadastraisCepRequest,
  dadosCadastraisRequest,
  dadosCadastraisRespFinanceiroCepRequest,
  dadosCadastraisRespFinanceiroRequest,
  documentoAssinadoRequest,
  documentosRequest,
  importarDadosCadastraisRequest,
  inserirAdesaoRequest,
  inserirBeneficiarioAdesaoRequest,
  inserirDocumentoAdesaoRequest,
  parametrosConfirmacaoRequest,
  parenteParticipanteAtivoResposta,
  parenteParticipanteRequest,
  participanteAtivoResposta,
  participanteRequest,
  solicitaAssinaturaRequest,
  verificaInscricaoInstituidorRequest,
} from "./adesao";

import { AdesaoTypes } from "../ducks/adesao";

export default function* rootSaga() {
  yield all([
    takeLatest(
      AdesaoTypes.PARENTE_PARTICIPANTE_REQUEST,
      parenteParticipanteRequest
    ),
    takeLatest(
      AdesaoTypes.PARENTE_PARTICIPANTE_ATIVO_RESPOSTA,
      parenteParticipanteAtivoResposta
    ),
    takeLatest(AdesaoTypes.PARTICIPANTE_REQUEST, participanteRequest),
    takeLatest(
      AdesaoTypes.PARTICIPANTE_ATIVO_RESPOSTA,
      participanteAtivoResposta
    ),
    takeLatest(AdesaoTypes.DADOS_CADASTRAIS_REQUEST, dadosCadastraisRequest),
    takeLatest(
      AdesaoTypes.DADOS_CADASTRAIS_CEP_REQUEST,
      dadosCadastraisCepRequest
    ),
    ,
    takeLatest(
      AdesaoTypes.DADOS_CADASTRAIS_RESP_FINANCEIRO_REQUEST,
      dadosCadastraisRespFinanceiroRequest
    ),
    takeLatest(
      AdesaoTypes.DADOS_CADASTRAIS_RESP_FINANCEIRO_CEP_REQUEST,
      dadosCadastraisRespFinanceiroCepRequest
    ),
    takeLatest(
      AdesaoTypes.IMPORTAR_DADOS_CADASTRAIS_REQUEST,
      importarDadosCadastraisRequest
    ),
    takeLatest(AdesaoTypes.DOCUMENTOS_REQUEST, documentosRequest),
    takeLatest(AdesaoTypes.INSERIR_ADESAO_REQUEST, inserirAdesaoRequest),
    takeLatest(AdesaoTypes.ATUALIZAR_ADESAO_REQUEST, atualizarAdesaoRequest),
    takeLatest(
      AdesaoTypes.INSERIR_BENEFICIARIO_ADESAO_REQUEST,
      inserirBeneficiarioAdesaoRequest
    ),
    takeLatest(
      AdesaoTypes.INSERIR_DOCUMENTO_ADESAO_REQUEST,
      inserirDocumentoAdesaoRequest
    ),
    takeLatest(
      AdesaoTypes.ASSOCIADO_ESPECIAL_REQUEST,
      associadoEspecialRequest
    ),
    takeLatest(
      AdesaoTypes.SOLICITA_ASSINATURA_REQUEST,
      solicitaAssinaturaRequest
    ),
    takeLatest(
      AdesaoTypes.DOCUMENTO_ASSINADO_REQUEST,
      documentoAssinadoRequest
    ),
    takeLatest(
      AdesaoTypes.PARAMETROS_CONFIRMACAO_REQUEST,
      parametrosConfirmacaoRequest
    ),
    takeLatest(
      AdesaoTypes.VERIFICA_INSCRICAO_INSTITUIDOR_REQUEST,
      verificaInscricaoInstituidorRequest
    ),
  ]);
}
